import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as d3 from 'd3';
import { CONFIG } from "../config";
import PredictedRiskDetails from './PredictedRiskDetails';

export default function VehiclePredictedRiskDetails({ vehicleId, selectedDate }) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchVehiclePredictedRiskDetails = async () => {
    try {

      const response = await fetch(`${CONFIG.API_BASE_URL}/${CONFIG.VEHICLE_PREDICTED_RIOSK_DETAILS_URL}/${localStorage.getItem("tensor-user-id")}?vehicle_id=${vehicleId}&date_str=${selectedDate}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tensor-auth-token"),
        }
      });

      if (response.status === 401) {
        localStorage.removeItem('tensor-auth-token');
        localStorage.removeItem('tensor-user-id');
        navigate('/', { state: { message: 'Session expired please try again.', type: 'error' } });
        return;
      }

      const result = await response.json();
      if (result.success) {
        setData(result.data.predicted_risk_details);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Failed to send screenshot or fetch data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // Trigger on date change
  useEffect(() => {
    if (selectedDate) {
      setLoading(true);
      fetchVehiclePredictedRiskDetails();
    }
  }, [selectedDate]);

  return (
    <div className="w-full relative">
      {loading && (
        <div className="flex justify-center items-center min-h-[140px]">
          <svg className="w-6 h-6 text-blue-500 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"></circle>
            <path className="opacity-75" fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z">
            </path>
          </svg>
        </div>
      )}

      {!loading && (
        <PredictedRiskDetails data={data} />
      )}
    </div>
  );
}